export default "__VITE_ASSET__CWlJA4_a__"